export enum MenuTargetEnum {
  _self = '_self',
  _blank = '_blank',
}
